import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MobileFrame } from "@/components/MobileFrame";
import { PricingTelemetryPanel } from "@/components/admin/PricingTelemetryPanel";
import { useAdminRole } from "@/hooks/useAdminRole";

export default function AdminPricingTelemetry() {
  const navigate = useNavigate();
  const { isAdmin } = useAdminRole();

  useEffect(() => {
    if (isAdmin === false) navigate("/", { replace: true });
  }, [isAdmin, navigate]);

  if (isAdmin == null) return null;
  if (!isAdmin) return null;

  return (
    <MobileFrame>
      <div style={{ padding: "16px", color: "hsl(var(--ink))" }}>
        <PricingTelemetryPanel />
      </div>
    </MobileFrame>
  );
}
